import { ExAxios } from '@ExAxios';
import g from '@global';
import axios from 'axios';

/**
 * 获取数据字典
 * @param ident 数据字典标识
 * */
export const fethDic = (ident) =>
    new ExAxios((config) =>
        axios.get(`${g.getBaseServer()}/basic/sysDictValue/findList`, {
            params: { ident },
            ...config,
        }),
    );
